module.exports = __webpack_public_path__ + "07d142e8a4c4ef3326b78971c3dfe739.MP3";